import React from 'react';
import FinancialInstitutionForm from '../components/company/FinancialInstitutionForm';
import { PageContainer } from '../components/layout/PageContainer';

interface FinancialInstitutionProps {
  financialInstitutionId?: string;
}

const FinancialInstitution: React.FC<FinancialInstitutionProps> = ({ financialInstitutionId }) => {
  return (
    <PageContainer>
      <FinancialInstitutionForm financialInstitutionId={financialInstitutionId} />
    </PageContainer>
  );
};

export default FinancialInstitution;
